export default __webpack_public_path__ + "images/c4e99947e79e45a0732d96d0d4057a31.png";